import React, { useState, useEffect } from "react";
import Category from "../components/Category";
import HeroSlide from "../components/HeroSlide";
import ProductSlide from "../components/ProductSlide";
import axios from "axios";
import { baseurl, imgurl } from "../baseurl"; // Ensure imgurl is imported
import CategoryMobile from "../components/CategoryMobile";
import ProductCardSlideMobile from "./HomeCompo/ProductCardSlideMobile";

function Home() {
  const [banners, setBanners] = useState([]);
  const [categories, setCategories] = useState([]);
  const [ads, setAds] = useState([]); // New state for ads
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const res = await axios.get(`${baseurl}getHomePageData`);
        if (res.data.success) {
          setBanners(res.data.banners || []);
          setCategories(res.data.categories || []);
          setAds(res.data.ads || []); // Set ads from response
        }
      } catch (err) {
        console.error("Error fetching homepage data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchHomeData();
  }, []);

  // Helper to render Ad Sections
  const AdSection = ({ index }) => {
    // Determine how many ads to show (e.g., 3 square or 2 rectangle)
    // Here we logic: show 3 ads if available, otherwise 2.
    const adsToShow = ads.slice(index * 3, (index * 3) + 3);
    if (adsToShow.length === 0) return null;

    const isThreeColumns = adsToShow.length === 3;

    return (
      <div className="container-fluid my-1 px-lg-2">
        <div className="row g-3">
          {adsToShow.map((ad) => (
            <div key={ad.uuid} className={isThreeColumns ? "col-4" : "col-6"}>
              <a href={ad.link} target="_blank" rel="noopener noreferrer">
                <img 
                  src={`${imgurl}${ad.image_path}`} 
                  alt={ad.title} 
                  className="img-fluid rounded shadow-sm hover-zoom" 
                  style={{ width: '100%', objectFit: 'cover', height: isThreeColumns ? 'auto' : '200px' }}
                />
              </a>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="d-none d-lg-block">
        <Category />
      </div>

      {loading ? (
        <div className="skeleton-banner mb-4"></div>
      ) : (
        <HeroSlide banners={banners} />
      )}

      {/* DESKTOP VIEW */}
      <div className="d-none d-lg-block">
        {loading ? (
          Array.from({ length: 3 }).map((_, i) => (
            <div className="skeleton-product-section" key={i}>
              <div className="skeleton-title"></div>
              <div className="skeleton-product-row">
                {Array.from({ length: 5 }).map((_, j) => (
                  <div className="skeleton-product" key={j}></div>
                ))}
              </div>
            </div>
          ))
        ) : (
          categories.map((cat, index) => (
            <React.Fragment key={cat.category_id}>
              <ProductSlide
                categoryName={cat.category_name}
                category_slug={cat.category_slug}
                products={cat.products}
              />
              {/* Insert Ad Section after every category slide */}
              <AdSection index={index} />
            </React.Fragment>
          ))
        )}
      </div>

      {/* MOBILE VIEW */}
      <div className="d-block d-lg-none">
        <CategoryMobile />
        {loading ? (
          <div className="skeleton-product-section">
            <div className="skeleton-title"></div>
            <div className="skeleton-product-row">
              <div className="skeleton-product"></div>
              <div className="skeleton-product"></div>
            </div>
          </div>
        ) : (
          categories.slice(0, 5).map((cat, index) => (
            <React.Fragment key={cat.category_id}>
              <ProductCardSlideMobile
                categoryName={cat.category_name}
                category_slug={cat.category_slug}
                products={cat.products}
              />
              {/* Show 1 ad at a time on mobile to save space */}
              {ads[index] && (
                <div className="px-3 my-3">
                  <a href={ads[index].link}>
                    <img 
                      src={`${imgurl}${ads[index].image_path}`} 
                      className="img-fluid rounded" 
                      alt="ad" 
                    />
                  </a>
                </div>
              )}
            </React.Fragment>
          ))
        )}
      </div>

      <style>{`
        .hover-zoom {
          transition: transform 0.3s ease;
        }
        .hover-zoom:hover {
          transform: scale(1.02);
        }
        /* 🔹 Skeleton animation */
        @keyframes shimmer {
          0% { background-position: -200px 0; }
          100% { background-position: 200px 0; }
        }
        .skeleton-banner, .skeleton-title, .skeleton-product {
          background: linear-gradient(90deg, #eee 25%, #f5f5f5 37%, #eee 63%);
          background-size: 400% 100%;
          animation: shimmer 1.4s infinite linear;
        }
        .skeleton-banner { height: 300px; border-radius: 10px; margin: 20px auto; width: 95%; }
        .skeleton-product-section { margin: 20px 0; padding: 10px 15px; }
        .skeleton-title { height: 20px; width: 200px; margin-bottom: 15px; border-radius: 4px; }
        .skeleton-product-row { display: flex; gap: 15px; overflow-x: auto; }
        .skeleton-product { flex: 0 0 150px; height: 180px; border-radius: 10px; }
      `}</style>
    </>
  );
}

export default Home;